import { CardListFieldsFragment } from '@src/generated/graphql';
import { highlightBracketedText } from 'src/utils/utils';

type TestimonialProps = {
  content: CardListFieldsFragment;
  className?: string;
};

const Testimonial = ({ content, className = "" }: TestimonialProps) => {
  const { title, cardsCollection, description } = content;
  const cards = cardsCollection?.items || [];
  

  return (
    <div className={`safe-animation-section ${className}`}>
      <div className="container-fluid custom-spacer-col features-space">
        <div className="safe-animation-inner">
          <div className="safe-left">
            <h2
              className="highlight-bracket-text"
              dangerouslySetInnerHTML={{ __html: highlightBracketedText(title ?? "", "bold") }}
              style={{ textAlign: "start" }}
            />
            {description && <p>{description}</p>}
          </div>
          <div className="safe-right">
            <div className="saf-box-inner">
              {cards.map((card, index) => (
                <div key={index} className="safe-box">
                  <div className="safe-img">
                    {card?.cardIcon?.url ? (
                      <img src={card.cardIcon.url} alt={card.cardIcon.title || ''} />
                    ) : null}
                  </div>
                  <h3>{card?.cardTitle}</h3>
                  <p>
                    {card?.cardDescription?.json.content[0].content[0].value}
                  </p>
                 
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;